<template>
    <div id="login">
        <div class="login_panel">
            <img class="panel_bj" src="./img/loading.gif" alt="" srcset="">
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                invite_code:""
            }
        },
        created() {
            this.invite_code = this.$route.query.invite_code || '';
            localStorage.setItem("invite_code", this.invite_code);
            this.$router.push("/")
        },
        mounted(){
            
        },
        methods: {
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #login{
        height: 100vh;
        width: 100vw;
        min-width: 1050px;
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #e5e7eb;
        .login_panel{
            width: 100%;
            max-width: 1000px;
            border-radius: 12px;
            text-align: center;
            .panel_bj{
                width: 30%;
            }
        }
    }
</style>